import React from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line react/prop-types
const Header = ({ children }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center flgshp-header">
    <Helmet>
      <title>{children}</title>
    </Helmet>
    {children}
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/Flagship/components/Header.jsx